import { H4 } from "styles/jss/Layout.styles";

export default function SecondTitle({ children, classname }) {
  return <H4 className={classname}>{children}</H4>;
}
